// extracted by mini-css-extract-plugin
export var formLink = "FormLink-module--formLink--2c01b";
export var wrapper = "FormLink-module--wrapper--4cdca";